export enum QueryKey {
  listMemberGroups = 'listMemberGroups',
  getPendencies = 'getPendencies',
  getPendingInvites = 'getPendingInvites',
  postAcceptInvite = 'postAcceptInvite',
  postRejectInvite = 'postRejectInvite',
  getSmartInstallmentCyclesSummarie = 'getSmartInstallmentCyclesSummarie',
  getInProgressSmartInstallmentCycles = 'getInProgressSmartInstallmentCycles '
}
